<div [ngClass]="{ 'w-full h-dvh overflow-auto flex flex-col': true }">
  <div [ngClass]="{ 'py-6 w-full max-w-[1000px] mx-auto': true }">
    <div class="flex items-center pl-[13px]">
      <a
        class="flex items-center font-medium text-gray-900 title-font md:mb-0"
        routerLink="/user/dashboard"
        nz-tooltip
        nzTooltipPlacement="right"
        nzTooltipTitle="Home"
      >
        <img
          [src]="'assets/images/logo_with_name.png'"
          class="w-[130px] rounded-full overflow-hidden object-fill"
        />
      </a>
    </div>
  </div>

  @if (billType() === "DN") {
    <app-demand-notice-invoice
      [data]="demandNoticebillQueryResponse.data() || {}"
      [isLoading]="isLoading()"
      [isDataExternal]="true"
    ></app-demand-notice-invoice>
  } @else if (billType() === "CDN") {
    <app-consolidated-demand-notice-invoice
      [isLoading]="isLoading()"
    ></app-consolidated-demand-notice-invoice>
  } @else if (billType() === "Special") {
    <app-special-invoice
      [data]="specialbillQueryResponse.data() || {}"
      [isLoading]="specialbillQueryResponse.isFetching()"
      [isDataExternal]="true"
    ></app-special-invoice>
  } @else {
    <app-receipt
      [receiptData]="receiptData()"
      [isLoading]="isLoading()"
      [isInvoice]="isInvoice"
    ></app-receipt>

    <!-- DN, CDN and Special invoices render their own payment gateway modal -->
    <app-payment-gateway-modal></app-payment-gateway-modal>
  }
</div>
